<main id="main">
    <kokos-header [page]="page"
                  [title]="'breadcrumb.mailbox' | i18next"></kokos-header>
    <div class='container-fluid'>

        @if (postfachRestricted) {
            <kokos-postfach-eingeschraenkt></kokos-postfach-eingeschraenkt>
        }
        <kokos-postfach-content
                id='kpf-nachrichten-home'
                [benutzerRechte]='benutzerRechte'
                [nachrichtenOrdner]="nachrichtenOrdner"
                [selectedFolder]="selectedFolder"
                [postfachRestricted]="postfachRestricted"/>
    </div>
</main>